export function removeDuplicateObjects(arr) {
    const jsonObject = arr.map(JSON.stringify);
    const uniqueSet = new Set(jsonObject);
    return Array.from(uniqueSet).map((e)=>JSON.parse(e));
  }